import { create } from "zustand"
import { setBodyOverflow } from "@local/utils/src/setBodyOverflow"

interface CartState {
  isOpen: boolean
  isAnimating: boolean
  toggleOpen: (target?: boolean) => void
}

export const useCartLayout = create<CartState>((set) => ({
  isOpen: false,
  isAnimating: false,
  toggleOpen: (target) => {
    set(() => ({ isAnimating: true }))
    setTimeout(() => {
      set((state) => {
        const isOpen = target ?? !state.isOpen
        setBodyOverflow(isOpen, {
          id: "cart",
          noFixed: true,
        })
        return { isOpen }
      })
    }, 1)
    setTimeout(() => {
      set(() => ({ isAnimating: false }))
    }, 501)
  },
}))
